import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const AppShellSkeleton = () => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '768px',
        margin: '0 auto',
        padding: '16px',
        marginTop: '134px',
      }}
    >
      <Skeleton animation="wave" variant="rounded" height={44} sx={{ borderRadius: '14px' }} />

      <Box sx={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
        <Skeleton animation="wave" variant="rounded" width="32%" height={92} sx={{ borderRadius: '16px' }} />
        <Skeleton animation="wave" variant="rounded" width="32%" height={92} sx={{ borderRadius: '16px' }} />
        <Skeleton animation="wave" variant="rounded" width="32%" height={92} sx={{ borderRadius: '16px' }} />
      </Box>

      <Box sx={{ marginTop: '22px' }}>
        <Skeleton animation="wave" variant="text" width="45%" height={22} sx={{ transform: 'scale(1)' }} />
        <Box sx={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <Skeleton animation="wave" variant="rounded" width="48%" height={160} sx={{ borderRadius: '16px' }} />
          <Skeleton animation="wave" variant="rounded" width="48%" height={160} sx={{ borderRadius: '16px' }} />
        </Box>
      </Box>

      <Box sx={{ marginTop: '22px' }}>
        <Skeleton animation="wave" variant="text" width="35%" height={22} sx={{ transform: 'scale(1)' }} />
        <Skeleton animation="wave" variant="rounded" height={220} sx={{ borderRadius: '16px', marginTop: '10px' }} />
      </Box>
    </Box>
  );
};

export default AppShellSkeleton;
